//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getIndustry} from '@/assets/js/dict'
export default {
    created(){
        getIndustry().then(res=>{
            this.industrys= res;
        })
    },
    data: () => ({
       industrys:[],
        form: {
            // nickName:'',
            industry:'',
            // contactNumber:'',
            bankName:'',
            bankAccountName:'',
            bankAccountNum:''
        },
        userIndustryList:[],
        size:'normal',
        headers:''
    }),
    methods: {

        // 获取个人信息
        getInfo(){
            this.$get('/sys/user/info','',function(res){
                this.info=JSON.parse(JSON.stringify(res.data));
                this.form.nickName= res.data.nickName;
                this.form.contactNumber= res.data.contactNumber;
                var userIndustryList= res.data.userIndustryList;
                var industry=[];
                for (let i = 0; i < userIndustryList.length; i++) {
                    industry.push(userIndustryList[i].industry);
                }
                this.form.industry =industry;
                this.form.bankName= res.data.bankName;
                this.form.bankAccountNum=res.data.bankAccountNum;
                this.form.bankAccountName= res.data.bankAccountName;
            })
        },
        //切换行业
        changeIndustry(val){
            var industrylist=[];
            for (let i = 0; i < val.length; i++) {
                var obj={};
                obj.industry =val[i];
                obj.userType = this.info.currentUserType;
                obj.settledType = this.info.consumerType;
                industrylist.push(obj);
            }
            this.userIndustryList = industrylist;
        },

        // 检查银行卡号
        CheckBankNo(bankno) {
         var bankno = bankno.replace(/\s/g,'');
         if(bankno.length < 16 || bankno.length > 19) {
             this.$message.error("银行卡号长度必须在16到19之间");
             return false;
         }
         var num = /^\d*$/;//全数字
         if(!num.exec(bankno)) {
             this.$message.error("银行卡号必须全为数字");
             return false;
         }
         //开头6位
         var strBin = "10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99";
         if(strBin.indexOf(bankno.substring(0, 2)) == -1) {
             this.$message.error("银行卡号开头6位不符合规范");
             return false;
         }
         //Luhn校验
         if(!this.luhnCheck(bankno)){
             return false;
         }
         return true;
     },
     // 银行卡的规则
     luhnCheck(bankno){
          var lastNum=bankno.substr(bankno.length-1,1);//取出最后一位（与luhn进行比较）

          var first15Num=bankno.substr(0,bankno.length-1);//前15或18位
          var newArr=new Array();
          for(var i=first15Num.length-1;i>-1;i--){    //前15或18位倒序存进数组
              newArr.push(first15Num.substr(i,1));
          }
          var arrJiShu=new Array();  //奇数位*2的积 <9
          var arrJiShu2=new Array(); //奇数位*2的积 >9

          var arrOuShu=new Array();  //偶数位数组
          for(var j=0;j<newArr.length;j++){
              if((j+1)%2==1){//奇数位
                  if(parseInt(newArr[j])*2<9)
                  arrJiShu.push(parseInt(newArr[j])*2);
                  else
                  arrJiShu2.push(parseInt(newArr[j])*2);
              }
              else //偶数位
              arrOuShu.push(newArr[j]);
          }

          var jishu_child1=new Array();//奇数位*2 >9 的分割之后的数组个位数
          var jishu_child2=new Array();//奇数位*2 >9 的分割之后的数组十位数
          for(var h=0;h<arrJiShu2.length;h++){
              jishu_child1.push(parseInt(arrJiShu2[h])%10);
              jishu_child2.push(parseInt(arrJiShu2[h])/10);
          }

          var sumJiShu=0; //奇数位*2 < 9 的数组之和
          var sumOuShu=0; //偶数位数组之和
          var sumJiShuChild1=0; //奇数位*2 >9 的分割之后的数组个位数之和
          var sumJiShuChild2=0; //奇数位*2 >9 的分割之后的数组十位数之和
          var sumTotal=0;
          for(var m=0;m<arrJiShu.length;m++){
              sumJiShu=sumJiShu+parseInt(arrJiShu[m]);
          }

          for(var n=0;n<arrOuShu.length;n++){
              sumOuShu=sumOuShu+parseInt(arrOuShu[n]);
          }

          for(var p=0;p<jishu_child1.length;p++){
              sumJiShuChild1=sumJiShuChild1+parseInt(jishu_child1[p]);
              sumJiShuChild2=sumJiShuChild2+parseInt(jishu_child2[p]);
          }
          //计算总和
          sumTotal=parseInt(sumJiShu)+parseInt(sumOuShu)+parseInt(sumJiShuChild1)+parseInt(sumJiShuChild2);

          //计算luhn值
          var k= parseInt(sumTotal)%10==0?10:parseInt(sumTotal)%10;
          var luhn= 10-k;
          if(lastNum==luhn){
              return true;
          }else{
             // this.$message.error("银行卡号必须符合luhn校验");
             this.$message.error("银行卡号不正确");
              return false;
          }
      },

        // 保存数据
        save(){
            var data={
                currentUserType: this.info.currentUserType,
                nickName: this.form.nickName,
                contactNumber:this.form.contactNumber,
                userIndustryList: this.userIndustryList,
                bankAccountName: this.form.bankAccountName,
                bankAccountNum: this.form.bankAccountNum,
                bankName: this.form.bankName,
                id:this.info.id,
            }
            if(this.form.bankAccountNum){
               if(this.CheckBankNo(this.form.bankAccountNum)==true){
                   this.$put('/sys/user/',data,function(res){
                        if(res.code==200){
                            this.$message.success('保存成功!');
                            setTimeout(() => {
                                this.$router.back(-1);
                            }, 2000);
                        }else{
                            this.$message.error(res.msg)
                        }
                    },true)
               }
            }else{
                this.$put('/sys/user/',data,function(res){
                    if(res.code==200){
                        this.$message.success('保存成功!');
                        setTimeout(() => {
                            this.$router.back(-1);
                        }, 2000);
                    }else{
                        this.$message.error(res.msg)
                    }
                },true)
            }
            
        }
       
    },
    mounted() {
       this.getInfo()
    }
}
